import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import { Breadcrumb } from "react-bootstrap";
import HelpSosLayer from "./HelpSosLayer";


const HelpSosPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Help SOS" />

        {/* HelpSosLayer */}
        <HelpSosLayer />
      </MasterLayout>
    </>
  );
};

export default HelpSosPage;
